import { render, staticRenderFns } from "./EditUserRoleManage.vue?vue&type=template&id=38d36fd7&"
import script from "./EditUserRoleManage.vue?vue&type=script&lang=js&"
export * from "./EditUserRoleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports